const namespace = 'binder/studentDetails/';

export const FETCH_STUDENT_DETAILS = `${namespace}FETCH_STUDENT_DETAILS`;

export const STORE_STUDENT_DETAILS = `${namespace}STORE_STUDENT_DETAILS`;
